import {PollQuestionType} from '../../shared/models/poll';
import {GetPollResponsePayload, PollQuestionResponsePayload, PollAnswerRequestPayload} from '../../shared/models/api';
import {ValidationItem, validationPipe} from '../../shared/pipes';

export const singleFormName = 'single';

export const multipleFormName = 'multiple';

export const pollAnswersParser = (formData: Record<string, number | boolean>): PollAnswerRequestPayload[] => {
  const keys = Object.keys(formData);
  const results: PollAnswerRequestPayload[] = [];
  for (const key of keys) {
    if (key.startsWith(singleFormName)) {
      const findQA = new RegExp(/\w+_(\d+)/);
      const findResult = findQA.exec(key);
      if (findResult && findResult.length === 2) {
        results.push({
          // questionCode: +findResult[1] as number,
          id: formData[key] as number,
        });
      }
    } else if (key.startsWith(multipleFormName)) {
      const findQA = new RegExp(/\w+_(\d+)_(\d+)/);
      const findResult = findQA.exec(key);
      if (findResult && findResult.length === 3 && formData[key] === true) {
        results.push({
          // questionCode: +findResult[1] as number,
          id: +findResult[2] as number,
        });
      }
    }
  }
  return results;
};

export const pollFormGroupTransform = (
  questions?: PollQuestionResponsePayload[],
): Record<string, number | boolean | null> => {
  if (!questions) {
    return {};
  }
  const formData: Record<string, number | boolean | null> = {};
  for (const question of questions) {
    for (const answer of question?.answers || []) {
      if (question.typeId === PollQuestionType.manyAnswers) {
        formData[`${multipleFormName}_${question.id}_${answer.id}`] = !!answer.isSelected;
      } else {
        const name = `${singleFormName}_${question.id}`;
        if (formData[name] === undefined) {
          formData[name] = answer.isSelected ? answer?.id || null : null;
        } else if (formData[name] === null && answer.isSelected) {
          formData[name] = answer?.id || null;
        }
      }
    }
  }
  return formData;
};

export const getFormErrors = (poll: GetPollResponsePayload, formData: any) => {
  const {questions} = poll;
  const radioFields = pollFormGroupTransform(questions?.filter((item) => item.typeId === PollQuestionType.oneAnswer));
  const radioValidators: ValidationItem[] = Object.keys(radioFields).map((field) => ({
    names: field,
    error: 'Обязательное поле',
    type: 'required',
  }));
  return validationPipe(formData, [...radioValidators]);
};
